/**
 * iframes-ia.js — Relanza POR SCRIPT la carga de los iframes del bloque «Generar con IA».
 *
 * LA CAUSA (medida el 21-09-2026 con el arnés de ankawa-3, sin tocar producción; el detalle y
 * la tabla completa están en la PARTE 10 de CODEBASE_SUMMARY.md, gotcha 49):
 * en el HTML PUBLICADO los `<iframe sandbox srcdoc>` de `ai-custom` vienen HORNEADOS, así que
 * sus navegaciones `about:srcdoc` las arranca el PARSER. Con dos a la vez y el aislamiento de
 * iframes sandbox de Chrome de escritorio (`IsolateSandboxedIframes`, activo por defecto), esas
 * navegaciones se quedan COLGADAS cuando el proceso aislado tarda en arrancar (arranque en frío,
 * máquina cargada): la página no llega nunca a `load` y a veces ni a DOMContentLoaded.
 *   · base: 5/5 cuelgues en frío; con el arranque del renderer retardado, 2/8;
 *   · sin mover el iframe (secciones ya envueltas): 3/4 — el movimiento del shim NO es la causa;
 *   · lanzadas por SCRIPT en una tarea POSTERIOR al shim: 0/28 (srcdoc puesto tarde 0/6;
 *     quitarlo tras el parseo y reponerlo desde otro script 0/22).
 * No es el peso del canvas ni el movimiento (las dos hipótesis anteriores eran falsas).
 *
 * EL ARREGLO: quitar el `srcdoc` cancela la navegación que arrancó el parser; reponerlo —el
 * mismo valor, sin tocar nada más— la vuelve a lanzar, ahora desde un script y con el documento
 * ya parseado. `sandbox` NO se toca nunca.
 *
 * Y se repone en una TAREA POSTERIOR (`setTimeout 0`), no en la misma que la cirugía: medido,
 * reponerlo en la MISMA tarea en la que el shim mueve los iframes volvía a colgar la página cuando
 * se mueven dos veces (páginas publicadas antes del `<main>` horneado: 8 de 14, en dos tandas de
 * 4/8 y 4/6; con `<main>`, 0 de 8), y en una tarea aparte, 0 de 16 (8 con `<main>` y 8 sin él).
 * De paso, el `loading="lazy"` vuelve a decidir con la maqueta ya hecha.
 *
 * REGLA: ningún iframe sandbox HORNEADO que navegue el parser puede quedarse sin relanzar por
 * script. Si añades otra vía que sirva HTML compilado con iframes IA, envuélvela con esto.
 * La SPA pública y «Ver sitio» NO lo necesitan: pintan con `innerHTML` después del parseo, que
 * es justo el caso medido seguro.
 *
 * Módulo PURO (sin store ni DOM global): node-testeable (tests/test_iframes_ia.py). ES2019.
 */

/** Los iframes del bloque «Generar con IA» (la clase la emite `blocks/ai-custom.js`). */
export const SELECTOR_IFRAME_IA = 'iframe.ai-custom-frame';

/**
 * Ejecuta `cirugia()` con las navegaciones de los iframes IA de `raiz` DETENIDAS y las relanza en
 * la tarea siguiente: pase lo que pase (también si `cirugia` lanza, y entonces la excepción sigue
 * su camino), cada iframe recupera su `srcdoc` tal cual. Devuelve lo que devuelva `cirugia`.
 * Raíz nula o sin `querySelectorAll` ⇒ se limita a ejecutar `cirugia`.
 */
export function relanzarIframesIA(raiz, cirugia) {
    if (!raiz || typeof raiz.querySelectorAll !== 'function') return cirugia();
    const lista = raiz.querySelectorAll(SELECTOR_IFRAME_IA + '[srcdoc]');
    const detenidos = [];
    try {
        for (let i = 0; i < lista.length; i++) {
            const iframe = lista[i];
            const valor = iframe.getAttribute('srcdoc');
            iframe.removeAttribute('srcdoc');
            detenidos.push([iframe, valor]);
        }
        return cirugia();
    } finally {
        // Solo los que se detuvieron de verdad: reponer uno que nunca se quitó lo recargaría.
        if (detenidos.length) {
            setTimeout(function () {
                detenidos.forEach(function (par) { par[0].setAttribute('srcdoc', par[1]); });
            }, 0);
        }
    }
}
